import React from "react"
import PropTypes from "prop-types"
import { isEmpty } from "ramda"
import {
  Button,
  Card,
  Form,
  Icon,
  Modal,
  Dropdown,
  Menu,
} from "semantic-ui-react"
import { connect } from "react-redux"
import { signIn } from "../ducks/profile"
import { takeUserAuthData } from "../ducks/userAuthData"
import bind from "bind-decorator"
import { Link } from "react-router-dom"
import { withTranslation } from "react-i18next"
import i18next from "i18next"
import InputMask from "react-input-mask"
import ECPcomponent from "../components/ECPcomponent"

@connect(
  (state) => ({
    profile: state.profile,
  }),
  (dispatch) => ({
    onSignIn: (...data) => dispatch(signIn(...data)),
    takeUserAuthData: (...data) => dispatch(takeUserAuthData(...data)),
  }),
)
class LoginPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      login: "",
      pass: "",
      loginError: false,
      passError: false,
      isLoading: false,
      modal: false,
      lang: "",
      ecpEntry: false,
    }
  }
  componentDidMount() {
    if (localStorage.getItem("smatrtkassa-lang")) {
      let data = JSON.parse(localStorage.getItem("smatrtkassa-lang"))
      this.setState({ lang: data[1] })
      i18next.changeLanguage(data[0])
    } else {
      this.setState({ lang: "Рус" })
    }
  }

  changeLang = (lang, textLang) => {
    this.setState({ lang: textLang })
    i18next.changeLanguage(lang, () => {})
    localStorage.setItem("smatrtkassa-lang", JSON.stringify([lang, textLang]))
  }

  @bind
  signInCallback() {
    this.setState({ isLoading: false })
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  handleChange(e) {
    let name = e.target.name
    if (name === "iinOrBin") {
      name = "login"
    }
    this.setState({
      [name]: e.target.value,
      [name + "Error"]: false,
    })
  }

  @bind
  handleSubmit() {
    const { onSignIn } = this.props
    const { isLoading, login, pass } = this.state
    if (isLoading) return

    const loginError = isEmpty(login)
    const passError = isEmpty(pass)
    this.setState({ loginError, passError })

    if (loginError || passError) return

    this.setState({ isLoading: true })
    onSignIn(login, pass, this.signInCallback)
    // takeUserAuthData({ login, pass })
  }

  @bind
  handleModal() {
    this.setState({
      modal: !this.state.modal,
    })
  }

  render() {
    const { t } = this.props
    const { isLoading, login, pass, loginError, passError } = this.state
    const flipperClassName = "flipper-container" + (isLoading ? " flipped" : "")
    return (
      <div className="login-page-holder" data-test="login-page-holder">
        <Card fluid className="login-page">
          <Card.Content>
            <div className="login-page-title">
              <div className={flipperClassName}>
                <div className="flipper flipper-front">
                  <img
                    className="login-page-img"
                    src={require(`../assets/img/logo.png`)}
                  />
                </div>
                <div className="flipper flipper-back">
                  <div className="login-page-spinner">
                    <div className="spinner">
                      <div className="rect1" />
                      <div className="rect2" />
                      <div className="rect3" />
                      <div className="rect4" />
                      <div className="rect5" />
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <Menu>
                    <Menu.Item as={Dropdown} pointing text={this.state.lang}>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          content="Қаз"
                          onClick={() => {
                            this.changeLang("kz", "Қаз")
                          }}
                        />
                        <Dropdown.Item
                          content="Рус"
                          value="ru"
                          onClick={() => {
                            this.changeLang("ru", "Рус")
                          }}
                        />
                        <Dropdown.Item
                          content="Тадж"
                          value="tg"
                          onClick={() => {
                            this.changeLang("tg", "Тадж")
                          }}
                        />
                        <Dropdown.Item
                          content="Eng"
                          value="en"
                          onClick={() => {
                            this.changeLang("en", "Eng")
                          }}
                        />
                      </Dropdown.Menu>
                    </Menu.Item>
                  </Menu>
                </div>
                <div
                  style={{
                    padding: "5px",
                    cursor: "pointer",
                  }}
                  onClick={this.handleModal}
                >
                  <Icon name="question circle" size="large" color="green" />
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-center",
                  marginTop: 10,
                }}
              >
                {false && (
                  <Button
                    content={
                      this.state.ecpEntry ? "Вход по ИИН" : "Вход по ЭЦП"
                    }
                    onClick={() => {
                      this.setState({ ecpEntry: !this.state.ecpEntry })
                    }}
                    style={{
                      color: "black",
                      backgroundColor: "white",
                      border: "1px solid lightgray",
                      fontWeight: "100",
                    }}
                  />
                )}
              </div>
              <h2>Smartkassa|Admin</h2>
            </div>
            {this.state.ecpEntry ? (
              <ECPcomponent />
            ) : (
              <div className="login-page-form">
                <Form onSubmit={this.handleSubmit}>
                  <InputMask
                    mask="999999999999"
                    maskChar=""
                    onChange={this.handleChange}
                    value={login}
                  >
                    {(inputProps) => (
                      <Form.Input
                        {...inputProps}
                        // error={loginError}
                        placeholder={`Логин`}
                        // name="login"
                        // id="login"
                        name="iinOrBin"
                        id="iinOrBin"
                        // onChange={this.handleChange}
                        // value={login}
                        // data-test="loginInput"
                      />
                    )}
                  </InputMask>
                  <Form.Input
                    error={passError}
                    type="password"
                    placeholder="Пароль"
                    name="pass"
                    id="pass"
                    value={pass}
                    onChange={this.handleChange}
                    data-test="passwordInput"
                  />
                  <Button
                    type="submit"
                    color="green"
                    content={t("login")}
                    className="button"
                    data-test="signInBtn"
                  />
                </Form>
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Link to="/recover">
                <p style={{ marginTop: 15 }}>{t("forgetPassword")}</p>
              </Link>
              <Link to="/register">
                <p style={{ marginTop: 15 }}>{t("toRegister")}</p>
              </Link>
            </div>
          </Card.Content>
        </Card>
        <Modal
          open={this.state.modal}
          style={{ position: "fixed", top: "20%" }}
          size="small"
        >
          <Modal.Header style={{ backgroundColor: "#00B100", color: "white" }}>
            Инструкция
            <span
              style={{ float: "right", cursor: "pointer" }}
              onClick={this.handleModal}
            >
              <Icon name="close" />
            </span>
          </Modal.Header>
          <Modal.Content scrolling>
            <p align="justify">
              <span
                style={{
                  color: "#00B100",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                {t("step")} 1.{" "}
              </span>
              {t("step1")}
            </p>
            <br />

            <p align="justify">
              <span
                style={{
                  color: "#00B100",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                {t("step")} 2.{" "}
              </span>
              {t("step2")}
            </p>
            <br />

            <p align="justify">
              <span
                style={{
                  color: "#00B100",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                {t("step")} 3.{" "}
              </span>
              {t("step3")}
            </p>
          </Modal.Content>
        </Modal>
      </div>
    )
  }
}

LoginPage.propTypes = {
  onSignIn: PropTypes.func,
}

export default withTranslation()(LoginPage)

// export default LoginPage

// import React from "react"
// import PropTypes from "prop-types"
// import { isEmpty } from "ramda"
// import { Button, Card, Form, Icon, Modal } from "semantic-ui-react"
// import { connect } from "react-redux"
// import { signIn } from "../ducks/profile"
// import { takeUserAuthData } from "../ducks/userAuthData"
// import bind from "bind-decorator"
// import { Link } from "react-router-dom"

// @connect(
//   (state) => ({
//     profile: state.profile,
//   }),
//   (dispatch) => ({
//     onSignIn: (...data) => dispatch(signIn(...data)),
//     takeUserAuthData: (...data) => dispatch(takeUserAuthData(...data)),
//   }),
// )
// export default class LoginPage extends React.Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       login: "",
//       pass: "",
//       loginError: false,
//       passError: false,
//       isLoading: false,
//       modal: false,
//     }
//   }

//   @bind
//   signInCallback() {
//     this.setState({ isLoading: false })
//   }

//   @bind
//   // eslint-disable-next-line no-empty-pattern
//   handleChange(e) {
//     this.setState({
//       [e.target.name]: e.target.value,
//       [e.target.name + "Error"]: false,
//     })
//   }

//   @bind
//   handleSubmit() {
//     const { onSignIn } = this.props
//     const { isLoading, login, pass } = this.state
//     if (isLoading) return

//     const loginError = isEmpty(login)
//     const passError = isEmpty(pass)
//     this.setState({ loginError, passError })

//     if (loginError || passError) return

//     this.setState({ isLoading: true })
//     onSignIn(login, pass, this.signInCallback)
//     // takeUserAuthData({ login, pass })
//   }

//   @bind
//   handleModal() {
//     this.setState({
//       modal: !this.state.modal,
//     })
//   }

//   render() {
//     const { isLoading, login, pass, loginError, passError } = this.state
//     const flipperClassName = "flipper-container" + (isLoading ? " flipped" : "")
//     return (
//       <div className="login-page-holder" data-test="login-page-holder">
//         <Card fluid className="login-page">
//           <Card.Content>
//             <div className="login-page-title">
//               <div className={flipperClassName}>
//                 <div className="flipper flipper-front">
//                   <img
//                     className="login-page-img"
//                     src={require(`../assets/img/logo.png`)}
//                   />
//                 </div>
//                 <div className="flipper flipper-back">
//                   <div className="login-page-spinner">
//                     <div className="spinner">
//                       <div className="rect1" />
//                       <div className="rect2" />
//                       <div className="rect3" />
//                       <div className="rect4" />
//                       <div className="rect5" />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div
//                 style={{
//                   float: "right",
//                   transform: "translate(40px, -20px)",
//                   cursor: "pointer",
//                   padding: "5px",
//                 }}
//                 onClick={this.handleModal}
//               >
//                 <Icon name="question circle" size="large" color="green" />
//               </div>
//               <h2>Smartkassa|Admin</h2>
//             </div>
//             <div className="login-page-form">
//               <Form onSubmit={this.handleSubmit}>
//                 <Form.Input
//                   error={loginError}
//                   placeholder="Логин/ИИН"
//                   name="login"
//                   id="login"
//                   onChange={this.handleChange}
//                   value={login}
//                   data-test="loginInput"
//                 />
//                 <Form.Input
//                   error={passError}
//                   type="password"
//                   placeholder="Пароль"
//                   name="pass"
//                   id="pass"
//                   value={pass}
//                   onChange={this.handleChange}
//                   data-test="passwordInput"
//                 />
//                 <Button
//                   type="submit"
//                   color="green"
//                   content="Войти"
//                   className="button"
//                   data-test="signInBtn"
//                 />
//               </Form>
//             </div>
//             <div style={{ display: "flex", justifyContent: "space-between" }}>
//               <Link to="/recover">
//                 <p style={{ marginTop: 15 }}>Забыли пароль?</p>
//               </Link>
//               <Link to="/register">
//                 <p style={{ marginTop: 15 }}>Зарегистрироваться</p>
//               </Link>
//             </div>
//           </Card.Content>
//         </Card>
//         <Modal
//           open={this.state.modal}
//           style={{ position: "fixed", top: "20%" }}
//           size="small"
//         >
//           <Modal.Header style={{ backgroundColor: "#00B100", color: "white" }}>
//             Инструкция
//             <span
//               style={{ float: "right", cursor: "pointer" }}
//               onClick={this.handleModal}
//             >
//               <Icon name="close" />
//             </span>
//           </Modal.Header>
//           <Modal.Content scrolling>
//             <p align="justify">
//               <span
//                 style={{
//                   color: "#00B100",
//                   fontWeight: "bold",
//                   fontSize: "16px",
//                 }}
//               >
//                 Шаг 1.{" "}
//               </span>
//               Введите ваш ИИН
//             </p>
//             <br />

//             <p align="justify">
//               <span
//                 style={{
//                   color: "#00B100",
//                   fontWeight: "bold",
//                   fontSize: "16px",
//                 }}
//               >
//                 Шаг 2.{" "}
//               </span>
//               Введите пароль, созданный вами при регистрации. Если вы не помните
//               пароль, выберите опцию “Забыли пароль?”
//             </p>
//             <br />

//             <p align="justify">
//               <span
//                 style={{
//                   color: "#00B100",
//                   fontWeight: "bold",
//                   fontSize: "16px",
//                 }}
//               >
//                 Шаг 3.{" "}
//               </span>
//               Нажмите на кнопку “Войти”
//             </p>
//           </Modal.Content>
//         </Modal>
//       </div>
//     )
//   }
// }

// LoginPage.propTypes = {
//   onSignIn: PropTypes.func,
// }
